// Gründe der Leistungsfreigabe, getrennt nach externen und internen Gründen
export const FREIGABEGRUND_GRUPPEN = [
  {
    gruppe: 'Extern',
    optionen: [{ value: 'Cm', text: 'CM' }],
  },
  {
    gruppe: 'Intern',
    optionen: [
      { value: 'MehrereBereiche', text: 'Mehrere Bereiche' },
      { value: 'Repru', text: 'Repru' },
      { value: 'Pom', text: 'POM' },
      { value: 'Sonstiges', text: 'Sonstiges' },
      { value: 'Fit', text: 'FIT' },
      { value: 'Stammdaten', text: 'Stammdaten' },
      { value: 'DsmDom', text: 'DSM / DOM' },
      { value: 'Sales', text: 'Sales' },
      { value: 'DestinationYieldControlling', text: 'Destination Yield Controlling' },
    ],
  },
];

export function getFreigabegrundLabel(wert) {
  const option = FREIGABEGRUND_GRUPPEN.flatMap(gruppe => gruppe.optionen).find(o => o.value === wert);
  return option?.text ?? '-';
}
